import { ApiSchema } from "@api-types";
import { getFFService } from "services/ff.service";

export const hasFeature$ = (feature: ApiSchema.FF) => getFFService().featureEnabled$(feature);
